import { LocationTypes } from "../ActionTypes/LocationTypes"


 export default class LocationAction {
    static getActiveLocations = payload => {
        return {
            type : LocationTypes.GET_ACTIVE_LOCATIONS,
            payload : payload,
        }
    }
    
    static clearActiveLocations = () => {
        return {
            type: LocationTypes.CLEAR_ACTIVE_LOCATIONS ,
        };
    };

}